import { dispatchAiPanelCommand } from './components/AIChat/aiPanelCommand';

const resolveCommandInternalRoute = (commands) => {
  const route = commands?.InternalRedirect;
  if (typeof route !== 'string') return null;

  const normalized = route.trim();
  const path = normalized.split(/[?#]/, 1)[0];
  const pathSegments = path.split('/');
  if (
    !/^\/command(?:\/|$|\?|#)/i.test(normalized)
    || normalized.includes('\\')
    || pathSegments.includes('..')
  ) {
    return null;
  }

  return normalized;
};

export const createPlatformUiCommandHandler = (navigate) => (
  (commands, params) => {
    const result = {};

    if (dispatchAiPanelCommand(commands, params)) {
      result.AIPanel = true;
    }

    const commandRoute = resolveCommandInternalRoute(commands);
    if (commandRoute && typeof navigate === 'function') {
      navigate(commandRoute);
      result.InternalRedirect = true;
    }

    return result;
  }
);

